/**
 * Maintenance Banner
 * Shown to admin users when they're viewing the site during maintenance mode
 */

import { AlertTriangle, X } from 'lucide-react';
import { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

export function MaintenanceBanner() {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('maintenance-banner-dismissed') === 'true');
  const { t } = useLanguage();

  const dismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('maintenance-banner-dismissed', 'true');
  };

  if (dismissed) return null;

  return (
    <div className="bg-amber-500 text-white px-4 py-2">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm font-medium">
          <AlertTriangle className="w-4 h-4 flex-shrink-0" />
          <span>
            {t('maintenanceBanner.message', 'Maintenance Mode Active - Only admins can see the site. Public visitors see the maintenance page.')}
          </span>
        </div>
        <button
          onClick={dismiss}
          className="p-1 hover:bg-amber-600 rounded transition-colors"
          aria-label={t('maintenanceBanner.dismiss', 'Dismiss banner')}
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

export default MaintenanceBanner;
